import { useEffect, useState } from 'react';

import { useFetcher, useLoaderData } from '@remix-run/react';

import type { Pagination } from '~/interfaces/pagination';
import type { Recommendation } from '~/interfaces/recommendation';

export type LoaderData = {
  boostedRecommendations: Recommendation[];
  recommendations: Recommendation[];
  requestUrl: string;
  pagination: Pagination;
  metaTitle?: string;
};

const useRecommendations = () => {
  const {
    boostedRecommendations,
    recommendations: initialRecommendations,
    pagination: initialPagination,
  } = useLoaderData<LoaderData>();

  const fetcher = useFetcher();

  const [recommendations, setRecommendations] = useState(initialRecommendations);

  const [pagination, setPagination] = useState(initialPagination);

  const [page, setPage] = useState(1);

  const hasNextPage = pagination.page < pagination.total_pages;

  const loadNextPage = () => {
    fetcher.load(`/recommendations?index&page=${page + 1}`);
  };

  useEffect(() => {
    if (fetcher.data) {
      const { recommendations, pagination } = fetcher.data;

      setRecommendations((prev) => [...prev, ...recommendations]);
      setPagination(pagination);
      setPage((prev) => prev + 1);
    }
  }, [fetcher.data]);

  const isLoading = fetcher.state === 'loading';

  return {
    boostedRecommendations,
    recommendations,
    hasNextPage,
    loadNextPage,
    isLoading,
  };
};

export default useRecommendations;
